/**
 * Validación de email — Fase 0-bis (2026-07-16)
 *
 * DOCTRINA: una regex a mano NO puede validar un email. RFC 5322 admite en la
 * parte local '+', '!', '#', '%', '/', '=', '?', '^', comillas... Cualquier
 * lista de caracteres "permitidos" escrita a ojo acaba bloqueando a personas
 * reales. Quien valida un email de verdad es el CORREO DE CONFIRMACIÓN.
 *
 * Por eso aquí solo se descarta lo que no es un email ni de lejos (sin '@',
 * con espacios, sin dominio) y lo que la RFC 2606 declara no enrutable.
 * Todo lo demás pasa y lo decide el correo.
 *
 * HISTORIA: la versión anterior (sprint-14c) usaba
 *   /^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9.-]{2,}$/
 * más una lista 'SUSPICIOUS_DOMAINS' que comparaba contra la PRIMERA etiqueta
 * del dominio. Entre las dos bloqueaban, sin quererlo:
 *   · javier+primelab@gmail.com  → plus-addressing (RFC-válido, gesto de privacidad)
 *   · jack@x.com                 → 'x' estaba en la lista de letras sueltas
 *   · ana@test.com               → test.com es un dominio real y registrado
 *   · o'brien@gmail.com          → apóstrofo, RFC-válido
 * y dejaban pasar dev@mail.example.com, que sí es reservado.
 */

// Lo mínimo que no es un email: algo, arroba, algo, punto, algo. Sin espacios.
// Misma forma que EMAIL_REGEX en server.js — un solo contrato front/back.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// RFC 2606 — lo único que se sabe con certeza que jamás enruta.
const RESERVED_TLDS = ['test', 'example', 'invalid', 'localhost'] // §2
const RESERVED_DOMAINS = ['example.com', 'example.net', 'example.org'] // §3

function isEmailValid(em) {
  if (!EMAIL_RE.test(em)) return false
  const domain = (em.split('@')[1] || '').toLowerCase()
  if (RESERVED_TLDS.includes(domain.split('.').pop())) return false
  // el dominio reservado y cualquier subdominio suyo (mail.example.com)
  return !RESERVED_DOMAINS.some((d) => domain === d || domain.endsWith(`.${d}`))
}

module.exports = { isEmailValid, EMAIL_RE, RESERVED_TLDS, RESERVED_DOMAINS }
